import {
  styled,
  Tooltip as MUITooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material'
import { defaultTheme } from '../../theme'

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUITooltip {...props} classes={{ popper: className }} />
))(({ theme: muiTheme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: defaultTheme.colors.white,
    color: defaultTheme.colors.black,
    boxShadow: muiTheme.shadows[1],
    fontSize: 12,
    border: `1px solid ${defaultTheme.colors.black}`,
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&:before': {
      border: `1px solid ${defaultTheme.colors.black}`,
    },
    color: defaultTheme.colors.white,
  },
}))
